/*
 * @Author: bz2021 bz2021@mail.sdu.edu.cn
 * @Date: 2025-07-02 12:30:49
 * @LastEditors: bz2021 bz2021@mail.sdu.edu.cn
 * @LastEditTime: 2025-07-08 21:53:31
 * @FilePath: \a_span\frontend\management-app\src\pages\UserList.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Space,
  Button,
  message,
  Modal,
  Form,
  Select,
  Checkbox,
} from "antd";
import { getUser, createUser, updateUser, getMyUserList, deleteUser } from "../api/auth";
import { visibleStore } from '../api/store';
import { useAtom } from "jotai";
import { loggedInUserAtom } from "../store/userAtom";

const { Option } = Select;
const { FormItem } = Form;

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState("add"); // 'add' or 'edit'
  const [currentUser, setCurrentUser] = useState(null);
  const [isStoreModalVisible, setIsStoreModalVisible] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [currentDeleteUserId, setCurrentDeleteUserId] = useState(null);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [loggedInUser, setLoggedInUser] = useAtom(loggedInUserAtom);

  // 获取用户列表数据
  const fetchUsers = async () => {
    // 添加用户ID检查
    if (!loggedInUser?.user_id) {
      messageApi.warning("用户信息加载中，请稍候...");
      return;
    }
    setLoading(true);
    try {
      const response = await getMyUserList({
        page: pagination.current,
        page_size: pagination.pageSize,
        username: searchText,
        sort_by: sorting.sortBy,
        sort_order: sorting.sortOrder,
        master_id: loggedInUser.user_id,
      });
      setUsers(response.data.users);
      setTotal(response.data.total);
    } catch (error) {
      messageApi.error(
        "获取用户列表失败: " + (error.response?.data?.message || error.message)
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 仅当user_id存在时才请求数据
    if (loggedInUser?.user_id) {
      fetchUsers();
    }
  }, [
    pagination.current,
    pagination.pageSize,
    sorting.sortBy,
    sorting.sortOrder,
    loggedInUser?.user_id,
  ]);

  // 获取单个用户详情
  const fetchUserDetail = async (userId) => {
    try {
      const response = await getUser(userId);
      return response.data;
    } catch (error) {
      messageApi.error(
        "获取用户详情失败: " + (error.response?.data?.message || error.message)
      );
      return null;
    }
  };

  // 打开添加用户模态框
  const handleAdd = () => {
    setModalType("add");
    setCurrentUser(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  // 打开编辑用户模态框
  const handleEdit = async (userId) => {
    setLoading(true);
    const user = await fetchUserDetail(userId);
    setLoading(false);
    if (user) {
      setModalType("edit");
      setCurrentUser(user);
      form.setFieldsValue({
        username: user.username,
        email: user.email,
        admin: user.admin,
        super_admin: user.super_admin,
      });
      setIsModalVisible(true);
    }
  };

  const handleDelete = (userId) => {
    setCurrentDeleteUserId(userId);
    setIsDeleteModalVisible(true);
  };

  const handleViewStores = async (userId) => {
    setLoading(true);
    try {
      const response = await visibleStore(userId);
      setStoreData(response.data);
      setIsStoreModalVisible(true);
    } catch (error) {
      messageApi.error('获取店铺信息失败: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await deleteUser(currentDeleteUserId);
      messageApi.success('用户删除成功');
      fetchUsers();
      setIsDeleteModalVisible(false);
    } catch (error) {
      messageApi.error('删除用户失败: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  // 关闭模态框
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  // 提交表单（添加/编辑用户）
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (modalType === "add") {
        // 创建新用户
        await createUser({
              username: values.username,
              password: values.password,
              email: values.email,
              admin: false,
              super_admin: false,
              master_id: loggedInUser?.user_id,
              permissions: values.permissions,
            });
        messageApi.success("用户创建成功");
      } else {
        // 更新用户
        await updateUser(currentUser.user_id, {
          username: values.username,
          email: values.email,
          password: values.password || undefined,
          master_id: loggedInUser?.user_id,
          permissions: values.permissions,
        });
        messageApi.success("用户更新成功");
      }

      setIsModalVisible(false);
      fetchUsers(); // 重新加载用户列表
    } catch (error) {
      if (error.name !== "ValidationError") {
        messageApi.error(
          "操作失败: " + (error.response?.data?.msg || error.msg)
        );
      }
    } finally {
      setLoading(false);
    }
  };

  // 初始加载和参数变化时重新获取数据
  useEffect(() => {
    fetchUsers();
  }, [
    pagination.current,
    pagination.pageSize,
    sorting.sortBy,
    sorting.sortOrder,
  ]);

  // 搜索处理
  const handleSearch = () => {
    setPagination({ ...pagination, current: 1 });
    fetchUsers();
  };

  // 排序和分页变化处理
  const handleTableChange = (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorting({
      sortBy: sorter.field || "",
      sortOrder: sorter.order
        ? sorter.order === "ascend"
          ? "asc"
          : "desc"
        : "",
    });
  };

  const columns = [
    { title: "用户ID", dataIndex: "user_id", key: "user_id", sorter: true },
    { title: "用户名", dataIndex: "username", key: "username", sorter: true },
    { title: "邮箱", dataIndex: "email", key: "email" },
    {
      title: "创建时间",
      dataIndex: "created_at",
      key: "created_at",
      sorter: true,
      render: (createdAt) => {
        if (!createdAt) return "";
        const date = new Date(createdAt);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}.${month}.${day} ${hours}:${minutes}`;
      },
    },
    {
      title: "上次登录",
      dataIndex: "last_login",
      key: "last_login",
      sorter: false,
      render: (lastLogin) => {
        if (lastLogin == 0 || lastLogin === "0001-01-01T00:00:00Z")
          return "从未登录过";
        const diff = Date.now() - new Date(lastLogin).getTime();
        const minutes = Math.floor(diff / (1000 * 60));
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);

        if (months > 0) return `${months}个月前`;
        if (days > 0) return `${days}天前`;
        if (hours > 0) return `${hours}小时前`;
        return `${minutes}分钟前`;
      },
    },
    {
      title: "操作",
  key: "action",
  render: (_, record) => (
    <Space>
      <Button type="primary" onClick={() => handleViewStores(record.user_id)}>
          查看店铺
      </Button>
      <Button type="primary" onClick={() => handleEdit(record.user_id)}>
        编辑
      </Button>
      <Button danger onClick={() => handleDelete(record.user_id)}>
            删除
      </Button>
    </Space>
  ),
    },
  ];

  return (
    <div className="user-list-container">
      {contextHolder}
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleAdd}>
          添加用户
        </Button>
        <Input
          placeholder="输入用户名搜索"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onPressEnter={handleSearch}
          style={{ width: 200 }}
        />
        <Button type="primary" onClick={handleSearch}>
          搜索
        </Button>
      </Space>
      <Table
        columns={columns}
        dataSource={users?.map((user) => ({ ...user, key: user.user_id }))}
        loading={loading}
        pagination={{
          ...pagination,
          total,
          showSizeChanger: true,
          showTotal: (total) => `共 ${total} 条记录`,
        }}
        onChange={handleTableChange}
      />
      <Modal
        title={modalType === "add" ? "添加用户" : "编辑用户"}
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} layout="vertical" initialValues={{ ...currentUser, permissions: currentUser?.permissions || [] }}>
          <Form.Item
            name="username"
            label="用户名"
            rules={[{ required: true, message: "请输入用户名" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="邮箱"
            rules={[
              { required: true, message: "请输入邮箱" },
              { type: "email", message: "请输入有效的邮箱地址" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="permissions"
            label="权限"
            rules={[{ required: true, message: '请选择至少一项权限' }]}
          >
            <Checkbox.Group
              options={[
                { label: '查看库存', value: 1 },
                { label: '查看统计', value: 2 }
              ]}
              style={{ display: 'flex', gap: '16px' }}
            />
          </Form.Item>
          {modalType === "add" && (
            <Form.Item
              name="password"
              label="密码"
              rules={[{ required: true, message: "请输入密码" }]}
            >
              <Input.Password />
            </Form.Item>
          )}
          {modalType === "edit" && (
            <Form.Item name="password" label="密码">
              <Input.Password placeholder="输入新密码（不输入则不修改）" />
            </Form.Item>
          )}
          <Form.Item>
            <Space>
              <Button onClick={handleCancel}>取消</Button>
              <Button type="primary" loading={loading} onClick={handleSubmit}>
                {modalType === "add" ? "创建" : "更新"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="确认删除"
        open={isDeleteModalVisible}
        onOk={handleConfirmDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        confirmLoading={loading}
      >
        <p>确定要删除此用户吗？</p>
      </Modal>
        <Modal
          title="店铺信息"
          open={isStoreModalVisible}
          onCancel={() => setIsStoreModalVisible(false)}
          footer={[
            <Button key="close" onClick={() => setIsStoreModalVisible(false)}>
              关闭
            </Button>
          ]}
          width={800}
          destroyOnClose
          centered
        >
          <Table
  dataSource={storeData}
  columns={[
    { title: '店铺ID', dataIndex: 'store_id', key: 'store_id', width: 100 },
    { title: '店铺名称', dataIndex: 'store_name', key: 'store_name', width: 180, ellipsis: true },
    { title: '地址', dataIndex: 'address', key: 'address', ellipsis: true },
    { title: '位置', dataIndex: 'location', key: 'location', width: 120 },
    { title: '联系方式', dataIndex: 'contact_number', key: 'contact_number', width: 150 },
  ]}
  rowKey="store_id"
  bordered
  pagination={{ pageSize: 5 }}
  size="middle"
  style={{ marginTop: 16 }}
  rowClassName={(record, index) => index % 2 === 0 ? 'table-row-even' : ''}
/>
        </Modal>
      </div>
  );
};

export default UserList;
